import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
const directionOffset: Record<string, string> = {
  up: 'translate3d(0, 30px, 0)',
  down: 'translate3d(0, -30px, 0)',
  left: 'translate3d(30px, 0, 0)',
  right: 'translate3d(-30px, 0, 0)',
  none: 'translate3d(0, 0, 0)'
};
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // If IntersectionObserver isn't available, just show.
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      });
    }, {
      rootMargin: '0px 0px -100px 0px',
      threshold: 0.01
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={className} style={{
    opacity: visible ? 1 : 0,
    transform: visible ? 'translate3d(0, 0, 0)' : directionOffset[direction],
    transition: `opacity 0.7s cubic-bezier(0.21, 0.47, 0.32, 0.98) ${delay}s, transform 0.7s cubic-bezier(0.21, 0.47, 0.32, 0.98) ${delay}s`,
    willChange: visible ? 'auto' : 'opacity, transform'
  }} data-id="element-299">
      {children}
    </div>;
}